export default {
  ArrowDownIcon: require('../../engage/assets/icons/arrow-down.svg').default,
  ArrowUpIcon: require('../../engage/assets/icons/arrow-up.svg').default,
  greenCheck: require('../../engage/assets/icons/greenCheck.svg').default,
  SpinnerIcon: require('../../engage/assets/icons/spinner.svg').default,
};
